import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { useNotifications } from "@toolpad/core";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setNewPassword } from "../services/authService";

export default function NewPasswordPage() {
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const location = useLocation();
  const { email, cisloOdberatele, isVerified } = location.state || {};

  const navigate = useNavigate();
  const [inputError, setInputError] = useState("");
  const notifications = useNotifications();

  useEffect(() => {
    if (!isVerified || cisloOdberatele === "") {
      navigate("/login", { replace: true });
    }
  }, [cisloOdberatele, isVerified, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setInputError("");
    if (password !== passwordConfirm) {
      setInputError("Hesla se neshodují");
      return;
    }

    const result = await setNewPassword(email, cisloOdberatele, password);

    if (result.success) {
      notifications.show("Heslo bylo úspěšně změněno.", {
        severity: "success",
        autoHideDuration: 5000,
      });
      navigate("/login", { replace: true });
    } else {
      setInputError(result.message || "Heslo se nepodařilo změnit.");
    }
  };

  return (
    <Box
      style={{ maxWidth: "400px", margin: "10px auto" }}
      component="form"
      onSubmit={onSubmit}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.7rem" }, // responsive font size
          mt: 4,
          mb: 2,
        }}
      >
        Obnova hesla
      </Typography>
      {
        <Alert sx={{ mb: 2 }} severity="info">
          Nastavte nové heslo pro č. odběratele {cisloOdberatele}
        </Alert>
      }
      {inputError && (
        <Alert sx={{ mb: 2 }} severity="error">
          {inputError}
        </Alert>
      )}
      <TextField
        label="Heslo"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        autoComplete="off"
        required
        sx={{ mb: 1 }}
      />
      <TextField
        label="Heslo znovu"
        type="password"
        value={passwordConfirm}
        onChange={(e) => setPasswordConfirm(e.target.value)}
        fullWidth
        autoComplete="off"
        required
        sx={{ mb: 1 }}
      />
      <Button
        type="submit"
        variant="contained"
        sx={{ display: "block", m: "0 auto", width: "200px" }}
      >
        Změnit heslo
      </Button>
      <Button
        variant="outlined"
        style={{ display: "block", margin: "5px auto", width: "200px" }}
        onClick={() => navigate("/login")}
      >
        Přihlásit se
      </Button>
    </Box>
  );
}
